import { Box, Group, Paper, Stack, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { BatchTypeEnum } from '@e-origin/shared';

import { DropdownArrow } from '@components';
import { STORAGE_KEYS } from '@utils';
import { getStoredCriteria, setStoredCriteria } from '../../../criteria.caching';
import classes from './BatchView.module.css';

interface BatchViewOption {
  value: BatchTypeEnum;
  label: string;
  'data-pw': string;
}

const batchViewOptions: BatchViewOption[] = [
  { value: BatchTypeEnum.HIGH_VALUES, label: 'High Values', 'data-pw': 'batch-dropdown-high-values' },
  { value: BatchTypeEnum.HIGH_VALUES_EXPORT, label: 'Export', 'data-pw': 'batch-dropdown-export' },
  { value: BatchTypeEnum.LOW_VALUES, label: 'Low Values', 'data-pw': 'batch-dropdown-low-values' },
];

interface BatchViewProps {
  value: BatchTypeEnum;
  onChange: (value: BatchTypeEnum) => void;
  excludeList?: BatchTypeEnum[];
}

export const BatchView: React.FC<BatchViewProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState<BatchViewOption>(batchViewOptions.find((opt) => opt.value === props.value));

  const ref = useRef(null);

  const onClickOutside = () => setIsOpen(false);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target) && !event.target.closest('#dropdown-container')) {
      onClickOutside();
    }
  };

  const setBatchView = (item: BatchViewOption) => {
    if (item.value !== props.value) {
      setStoredCriteria(STORAGE_KEYS.COOKIES.BATCH_VIEW, item.value);
      props.onChange(item.value);
      setSelectedOption(item);
    }
  };

  useEffect(() => {
    if (!getStoredCriteria(STORAGE_KEYS.COOKIES.BATCH_VIEW)) {
      setStoredCriteria(STORAGE_KEYS.COOKIES.BATCH_VIEW, BatchTypeEnum.HIGH_VALUES);
      setBatchView(batchViewOptions[0]);
    }

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <Group>
      <Box className={classes.container} id={'dropdown-container'} onClick={() => setIsOpen(!isOpen)}>
        <Stack gap={0}>
          <Text c={'#555454'} fz={13}>
            Batch view
          </Text>
          <Text c={'#555454'} data-pw="batch-dropdown">
            {selectedOption?.label}
          </Text>
        </Stack>
        <DropdownArrow isOpen={isOpen} />
      </Box>

      {isOpen && (
        <Paper className={classes.dropdownList} ref={ref}>
          {batchViewOptions
            .filter((option) => !props.excludeList?.includes(option.value))
            .map((item: any) => {
              return (
                <Box
                  className={classes.dropdownItem}
                  key={item.value}
                  onClick={() => {
                    setBatchView(item);
                    setIsOpen(false);
                  }}
                  data-pw={item['data-pw']}
                >
                  <Text pl={15} c={'#555454'}>
                    {item.label}
                  </Text>
                </Box>
              );
            })}
        </Paper>
      )}
    </Group>
  );
};
